import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';

class InIframe extends React.PureComponent {
    static propTypes = {
        content: PropTypes.string,
    };

    appendIframe = parentNode => {
        const { content } = this.props;

        const newFrame = document.createElement('iframe');

        newFrame.src = content;
        // FF、IE隐藏边框有效
        newFrame.frameBorder = 0;
        newFrame.scrolling = 'no';
        newFrame.width = '300px';
        newFrame.height = '600px';
        newFrame.scrolling = 'no';
        parentNode.appendChild(newFrame);
    };

    componentDidMount() {
        const iframeDom = this.refs.iframe;

        this.appendIframe(iframeDom);
    }

    render() {
        return <div ref="iframe" />;
    }
}

export default errorBoundary(InIframe);
